import { render } from "./AdministratorPostContent.vue?vue&type=template&id=7c3cfda1"
import script from "./AdministratorPostContent.vue?vue&type=script&lang=js"
export * from "./AdministratorPostContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__